import { useMutation } from '@tanstack/react-query';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { questionFunnelsPagesResponseFactory } from '../../utils/questionFunnelsPageFactory';

export function useTryToRequestQuestionPage() {
  const { mutateAsync } = useMutation({
    mutationFn: async (id: string) => {
      const response =
        await apiCancellationFunnels.tryToRequestGetOneCancellationFunnelPage(
          id
        );

      const factory = questionFunnelsPagesResponseFactory(response.data);

      return factory;
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao solicitar dados de Perguntas',
        'Ocorreu um erro ao solicitar dados de Perguntas, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestQuestionPage: mutateAsync,
  };
}
